import axios from 'axios'
import { API_BASE_URL } from '../../confing.js/baseUrl'

// Create axios instance with default config
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000, 
  headers: {
    'Content-Type': 'application/json',
  }
})

// Request interceptor to add auth token
apiClient.interceptors.request.use(
  (config) => {
    const user = JSON.parse(sessionStorage.getItem('user'))
    if (user?.token) {
      config.headers.Authorization = `Bearer ${user.token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Response interceptor to handle auth errors
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token expired or invalid
      sessionStorage.removeItem('user')
      window.location.href = '/login'
    }
    return Promise.reject(error)
  }
)

// get all users
const allUsers = async () => {
  const response = await apiClient.get('/api/users/')
  return response.data
}

// Register user (Admin only)
const register = async (userData) => {
  console.log(`service`,userData);
  const response = await apiClient.post('/api/users/', userData)
  return response.data
}


// Login user
const login = async (userData) => {
  const response = await apiClient.post('/api/users/login', userData)
  if (response.data?.data) {
    const userData = response.data.data
    sessionStorage.setItem('user', JSON.stringify(userData))
  }
  return response.data
}

// Get current user profile
const getProfile = async (userId) => {
  const response = await apiClient.get(`/api/users/` + userId)
  return response.data
}

// Update user profile
const updateProfile = async (userId, userData) => {
  const response = await apiClient.put(`/api/users/` + userId, userData)
  return response.data
}

// Delete user (Admin only)
const deleteUser = async (userId) => {
  const response = await apiClient.delete(`/api/users/${userId}`)
  return response.data
}

// logout user
const logout = () => {
  sessionStorage.removeItem('user')
}


const authService = {
  register,
  logout,
  login,
  allUsers,
  getProfile,
  updateProfile,
  deleteUser
}

export default authService